/**
 * @generated SignedSource<<4ab669355cea1b866d173b253a3cfa88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly name: string;
  readonly selectedGroupsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly groupId: string;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView">;
  readonly " $fragmentType": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef";
};
export type ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView"
    },
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "groupId"
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraMultipleGroupPickerField"
};
})();

(node as any).hash = "8432d03e246ec4da1c38b93c6858f003";

export default node;
